export const sanitizeApiName = (name) => {
  // Remove any characters that aren't letters, numbers, underscores, or hyphens
  return name.replace(/[^a-zA-Z0-9_-]/g, '');
};

export const validateApiName = (name) => {
  return /^[a-zA-Z0-9_-]+$/.test(name);
}; 